export default __webpack_public_path__ + "static/media/echo-burning.b3de34e4.mp3";